module.exports = __webpack_public_path__ + "img/vaga2.62d5ad54.jpg";